import { Record as record } from 'immutable';
import PlusBus from './PlusBus';
import OrderFare from './Fare';
import { construct, resolve } from '../../helpers/LinkMapper';
import _ from 'lodash';


const defaults = {
    outwardSingle: null,
    returnSingle: null,
    'return': null,
    season: null,
    fareOnly: null,
    roversRangers: null,
    plusBus: new PlusBus()
};


class OrderTripFares extends record(defaults) {
    static fromJSON (json = {}) {
        return construct(OrderTripFares, json, {
            outwardSingle: resolve.as(OrderFare),
            returnSingle: resolve.as(OrderFare),
            'return': resolve.as(OrderFare),
            season: resolve.as(OrderFare),
            fareOnly: resolve.as(OrderFare),
            roversRangers: resolve.as(OrderFare),
            plusBus: resolve.as(PlusBus)
        });
    }

    getDaySaveFare () {
        return this.find((fare) => fare instanceof OrderFare && fare.isDaySave());
    }

    getRoversRangersFare () {
        return this.find((fare) => fare instanceof OrderFare && fare.isRoversRangers());
    }

    isOpenReturn () {
        return this.return && _.result(this, 'return.returnJourney.legs.isEmpty');
    }

    hasTravelcard () {
        return (this.outwardSingle && this.outwardSingle.isTravelcard()) ||
                (this.returnSingle && this.returnSingle.isTravelcard()) ||
                (this.return && this.return.isTravelcard()) ||
                (this.season && this.season.isTravelcard()) ||
                (this.fareOnly && this.fareOnly.isTravelcard());
    }

    isCrossLondon () {
        return (this.outwardSingle && this.outwardSingle.isCrossLondon()) ||
                (this.returnSingle && this.returnSingle.isCrossLondon()) ||
                (this.return && this.return.isCrossLondon()) ||
                (this.season && this.season.isCrossLondon()) ||
                (this.fareOnly && this.fareOnly.isCrossLondon());
    }

    // Backfills originalOrderPurchaseDate onto every fare that doesn't already have one
    withOriginalPurchaseDate (originalOrderPurchaseDate) {
        return ['outwardSingle', 'returnSingle', 'return', 'season', 'fareOnly'].reduce((fares, fareKey) => {
            const fare = fares.get(fareKey);
            if (!fare || fare.originalOrderPurchaseDate) {
                return fares;
            }
            return fares.set(fareKey, fare.set('originalOrderPurchaseDate', originalOrderPurchaseDate));
        }, this);
    }
}

export default OrderTripFares;
